import { useState } from 'react';
import * as E from '../lib/engine.js';
import { Dots, ElIcon } from './PeopleBits.jsx';
import { GROUP_LABEL } from '../lib/rules.js';
import './life-scenes.css';

const PROMISE_LABEL = { pending: '이행 전', kept: '이행함', broken: '지키지 못함', cancelled: '약속 종료' };
const MEMORY_OUTCOME = { success: '성공', failure: '실패', skipped: '참여하지 않음', helped: '함께함', limited: '일부 도움', declined: '거절함', promised: '약속함', kept: '약속 이행', broken: '약속 미이행', accepted: '함께하기로 함', cancelled: '약속 종료' };

// 내 곁의 사람들: 슬롯 목록 + 선택한 사람 상세. 거리를 두면 되돌릴 수 없다
export default function PeopleView({ run, onDrift, onClose }) {
  const near = E.nearPeople(run);
  const gone = (run.people ?? []).filter((q) => q.status === 'drifted');
  const [sel, setSel] = useState(near[0]?.id ?? null);
  const [confirm, setConfirm] = useState(false);
  const q = near.find((x) => x.id === sel) ?? near[0] ?? null;
  const availability = q ? E.relationshipAvailability(run, q) : null;
  return (
    <div className="overlay">
      <div className="card wide peopleview" role="dialog" aria-modal="true" aria-labelledby="people-view-title">
        <div className="row" style={{ alignItems: 'center' }}>
          <h1 id="people-view-title" style={{ margin: 0 }}>내 곁의 사람들</h1><span className="chip">{near.length} / {E.MAX_PEOPLE}</span>
          <div className="grow" /><button onClick={onClose}>인생 화면으로 돌아가기</button>
        </div>
        <p className="muted small">가까운 사람 자리는 {E.MAX_PEOPLE}개로 고정됩니다. 그 사람의 분야에서 행동한 해에는 관계 능력치가 친밀도 증가에 반영됩니다.</p>
        <div className="pv">
          <div className="pvleft">
            <div className="slots">
              {Array.from({ length: E.MAX_PEOPLE }, (_, i) => near[i]).map((p, i) => p ? (
                <button key={p.id} className={`slot ${q?.id === p.id ? 'sel' : ''}`} onClick={() => { setSel(p.id); setConfirm(false); }}>
                  <b>{p.name}</b><span className="muted">{p.role} · {p.group}</span>
                  <span className="muted small">친밀도 {p.closeness} · 상성 <Dots n={p.compat} /></span>
                  <span className="muted small">신뢰 {Number.isFinite(p.trust) ? p.trust : '미기록'} · 함께한 기록 {p.memories?.length ?? 0}개</span>
                  {p.promise?.status === 'pending' && <span className="relationship-promise-chip">{p.promise.dueAge}세 약속</span>}
                  <div className="track"><div style={{ width: `${p.closeness}%` }} /></div>
                </button>
              ) : <div key={i} className="slot empty">빈 슬롯<br />새로운 만남을 기다리는 자리</div>)}
            </div>
            {gone.length > 0 && (
              <>
                <h3>소원해진 사람</h3>
                <div className="chips">{gone.map((p) => <span key={p.id} className="chip dash">{p.name} · {p.role} · {p.driftAge}세에 멀어짐</span>)}</div>
              </>
            )}
          </div>
          <aside className="panel pvdetail">
            {q ? (
              <>
                <span className="muted small">선택한 사람 상세</span>
                <h2 style={{ margin: '4px 0 0' }}>{q.name}</h2>
                <span className="muted">{q.role} · {q.sinceAge}세부터 함께</span>
                <div className="relationship-metrics">
                  <div><span>친밀도</span><b>{q.closeness}</b></div>
                  <div><span>신뢰</span><b>{Number.isFinite(q.trust) ? q.trust : '미기록'}</b></div>
                </div>
                {availability && <p className={`relationship-availability ${availability.available ? 'available' : 'unavailable'}`}><b>{availability.label}</b><span>{availability.reason}</span></p>}
                <h3>일간 기준 정보</h3>
                <p className="muted"><ElIcon el={E.personElement(q)} /> 일간 오행 {E.personElement(q)} · {E.personTrait(q)}형</p>
                <h3>나와의 상성</h3>
                <p className="muted"><Dots n={q.compat} /> {E.personRelationText(q)}</p>
                {q.promise && <div className={`relationship-promise promise-${q.promise.status}`}>
                  <b>{q.promise.dueAge}세 · {GROUP_LABEL[q.promise.field] ?? q.promise.field} 약속</b>
                  <span>{PROMISE_LABEL[q.promise.status] ?? q.promise.status}</span>
                </div>}
                <h3>관계의 선택과 함께한 일</h3>
                {q.memories?.length ? <ol className="relationship-memories">{q.memories.slice().sort((a, b) => b.age - a.age).slice(0, 8).map((memory, i) => (
                  <li key={`${memory.age}-${memory.kind}-${i}`}>
                    <span className="muted small">{memory.age}세{MEMORY_OUTCOME[memory.outcome] ? ` · ${MEMORY_OUTCOME[memory.outcome]}` : ''}</span>
                    <b>{memory.title}</b>
                    <p>{memory.text}</p>
                  </li>
                ))}</ol> : <p className="muted small">함께 선택한 일이 아직 없습니다.</p>}
                <h3>도움 기록</h3>
                {q.notes?.length ? q.notes.slice(0, 4).map((n, i) => <p key={i} className="muted small" style={{ display: 'block', margin: '2px 0' }}>{n.age}세 · {n.text}</p>)
                  : <p className="muted small" style={{ display: 'block' }}>아직 기록이 없어요</p>}
                <div className="grow" />
                {confirm
                  ? <div className="row"><button className="primary grow" onClick={() => { onDrift(q.id); setConfirm(false); setSel(null); }}>정말 거리를 둔다 (되돌릴 수 없어요)</button><button onClick={() => setConfirm(false)}>취소</button></div>
                  : <button onClick={() => setConfirm(true)}>거리를 둔다</button>}
              </>
            ) : <p className="muted">아직 곁에 있는 사람이 없어요. 살다 보면 먼저 말을 걸어 오는 사람이 생겨요.</p>}
          </aside>
        </div>
      </div>
    </div>
  );
}
